import React from 'react'
import styles from './custom_services_card.module.css'

export default function CustomServicesCard(props) {
    const lang = localStorage.getItem("lang")
    return (
        <div className={styles.card}>
            <span className={`${styles.number} ${!lang || lang === 'en' ? 'englishIranSans' : ''}`}>{props.num}</span>
            <div className={styles.service_img_container}>
                <img className={styles.service_img} alt="imageContainer" src={require(`../../assets/icons/${props.img}.svg`)} />
            </div>
            <span className={styles.title} >{props.title}</span>
            <span className={styles.service_img_des}>{props.des}</span>
        </div>
    )
}